import useSWR from "swr";

import { SortQueryDirection, usePaginationControls } from "@ds-cps/ui";

import { resourceEndpoints } from "@api/Endpoints";
import { fetcher } from "@utils/swr-utils";

import { PagedResourcesResponse } from "../models";
import { CreateParamsForResources } from "./CreateParamsForResources";
import { FilterOptions } from "./models";

export function useGetResources(
  activeSort: string,
  sortDirection: SortQueryDirection,
  filterOptions?: FilterOptions
) {
  const { pageIndex, pageSize } = usePaginationControls();

  const params = new CreateParamsForResources();
  params.withPagination(pageSize, pageIndex);
  params.withSortBy(activeSort);
  params.withSortDirection(sortDirection);
  params.withFilterOptions(filterOptions);

  const url = resourceEndpoints.getResources() + `?${params.toString()}`;

  const fetcherWithToken = (url: string) =>
    fetcher<PagedResourcesResponse>(url);

  const { data, error, isLoading, mutate } = useSWR(url, fetcherWithToken);

  return {
    resources: data?.resources,
    totalCount: data?.total,
    isLoading,
    hasError: Boolean(error),
    mutate
  };
}
